module.exports = __webpack_public_path__ + "static/media/ideation-image-2.ce7792d7.png";